// projects/humanresources-personnel/src/assets/i18n/*/hr-per-weapon.json
export class HrPerWeaponKey {
    private static readonly keyPrefix = 'hrPerWeapon';
    public static title = `${HrPerWeaponKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerWeaponKey.keyPrefix}.pageHeader`;
    public static trademark = `${HrPerWeaponKey.keyPrefix}.trademark`;
    public static caliber = `${HrPerWeaponKey.keyPrefix}.caliber`;
    public static serialNumber = `${HrPerWeaponKey.keyPrefix}.serialNumber`;
    public static productionYear = `${HrPerWeaponKey.keyPrefix}.productionYear`;
    public static licenseNo = `${HrPerWeaponKey.keyPrefix}.licenseNo`;
}
